import { render, staticRenderFns } from "./SalarySample.vue?vue&type=template&id=0a253d21&scoped=true"
import script from "./SalarySample.vue?vue&type=script&lang=js"
export * from "./SalarySample.vue?vue&type=script&lang=js"
import style0 from "./SalarySample.vue?vue&type=style&index=0&id=0a253d21&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a253d21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a253d21')) {
      api.createRecord('0a253d21', component.options)
    } else {
      api.reload('0a253d21', component.options)
    }
    module.hot.accept("./SalarySample.vue?vue&type=template&id=0a253d21&scoped=true", function () {
      api.rerender('0a253d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalarySample.vue"
export default component.exports